import React from 'react'
import styled from 'styled-components'

import PlusOIcon from '@pc/components/Works/Panel/shared/icons/PlusOIcon'

const ListOpenIconBase = styled(PlusOIcon)`
  color: #ed2d2d;
  height: 18px;
  width: 18px;
`

const ListOpenIcon = () => <ListOpenIconBase width={18} height={18} />

export default ListOpenIcon
